
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"gps","fill":"#8d98aa"}},[_c('path',{attrs:{"d":"M12 3.75A8.25 8.25 0 113.75 12 8.259 8.259 0 0112 3.75zm0 15A6.75 6.75 0 105.25 12 6.758 6.758 0 0012 18.75z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M12 8.25A3.75 3.75 0 118.25 12 3.754 3.754 0 0112 8.25zm0 6A2.25 2.25 0 109.75 12 2.253 2.253 0 0012 14.25zM12 4.75a.75.75 0 01-.75-.75V2a.75.75 0 01.75-.75.75.75 0 01.75.75v2a.75.75 0 01-.75.75zM4 12.75H2a.75.75 0 01-.75-.75.75.75 0 01.75-.75h2a.75.75 0 01.75.75.75.75 0 01-.75.75zM12 22.75a.75.75 0 01-.75-.75v-2a.75.75 0 01.75-.75.75.75 0 01.75.75v2a.75.75 0 01-.75.75zM22 12.75h-2a.75.75 0 01-.75-.75.75.75 0 01.75-.75h2a.75.75 0 01.75.75.75.75 0 01-.75.75z","opacity":".4"}})])])
          )
        }
      }
    